export default __webpack_public_path__ + "static/media/edit.cf3e5c1e.svg";